import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Đánh giá & mục tiêu (Mint-HR-Review). Tiền tố hrv. Tên kỳ / mục tiêu / người là dữ liệu, không dịch.
addMessages('vi', {
  'hrv.title': 'Đánh giá & mục tiêu',
  'hrv.sub': 'Năm 2026 · KPI vận hành ở Mint-KPI',
  'hrv.back': 'Về Nhân sự',
  'hrv.dStd': 'Chuẩn',
  'hrv.dCompact': 'Gọn',
  'hrv.density': 'Mật độ',
  'hrv.search': 'Tìm nhanh (Ctrl K)',
  'hrv.notif': 'Thông báo · 4 mới',
  'hrv.more': 'Thêm thao tác',
  'hrv.tCyc': 'Kỳ đánh giá',
  'hrv.tOkr': 'Mục tiêu OKR',
  'hrv.tComp': 'Khung năng lực',
  'hrv.pCyc': 'Mở kỳ đánh giá',
  'hrv.pOkr': 'Mục tiêu',
  'hrv.pEdit': 'Sửa khung',
  'hrv.pSave': 'Lưu khung',
  'hrv.kOpen': 'Kỳ đang mở',
  'hrv.kOpenU': 'cuối năm · 2 thử việc',
  'hrv.kSelf': 'Đã tự đánh giá',
  'hrv.kSelfU': 'kỳ cuối năm 2026',
  'hrv.kMgr': 'Quản lý đã chấm',
  'hrv.kMgrU': 'hạn 14/Dec',
  'hrv.kOkr': 'Mục tiêu Quý IV',
  'hrv.kAvg': 'TB {p}%',
  'hrv.cycles': 'Các kỳ đánh giá',
  'hrv.steps': 'Các bước',
  'hrv.remind': 'Tự nhắc trước hạn',
  'hrv.rd7': '7 ngày trước',
  'hrv.rd3': '3 ngày',
  'hrv.rd1': '1 ngày',
  'hrv.rdHei': 'Qua Hei',
  'hrv.rdMail': 'Qua mail',
  'hrv.remindAll': 'Nhắc {n} người chưa xong',
  'hrv.people': 'Người trong kỳ',
  'hrv.filterSt': 'Lọc theo trạng thái',
  'hrv.fAll': 'Tất cả',
  'hrv.fSelf': 'Chưa tự đánh giá',
  'hrv.fMgr': 'Chờ quản lý chấm',
  'hrv.fDone': 'Xong',
  'hrv.cStaff': 'Nhân sự',
  'hrv.cMgr': 'Quản lý chấm',
  'hrv.cSelf': 'Tự đánh giá',
  'hrv.cMgr2': 'Quản lý',
  'hrv.cKpiTip': 'Điểm chất lượng KPI kỳ · Mint-KPI',
  'hrv.remindOne': 'Nhắc',
  'hrv.remindAria': 'Nhắc {u}',
  'hrv.noMatch': 'Không có người khớp bộ lọc.',
  'hrv.stOpen': 'Đang mở',
  'hrv.stDraft': 'Nháp',
  'hrv.stClosed': 'Đã đóng',
  'hrv.p0': 'Chưa làm',
  'hrv.p1': 'Nháp',
  'hrv.p2': 'Đã nộp',
  'hrv.lvAll': 'Tất cả cấp',
  'hrv.lvCo': 'Công ty',
  'hrv.lvDept': 'Phòng',
  'hrv.lvAria': 'Lọc theo cấp',
  'hrv.okrCap': 'Quý IV/2026 · check-in hằng tuần',
  'hrv.okrKpi': 'Số KPI vận hành ở Mint-KPI ↗',
  'hrv.checkin': 'Check-in',
  'hrv.dec': 'Giảm {k}',
  'hrv.inc': 'Tăng {k}',
  'hrv.cOk': 'Đúng hướng',
  'hrv.cWarn': 'Cần chú ý',
  'hrv.cErr': 'Rủi ro',
  'hrv.pos': 'Chức danh',
  'hrv.grid': 'Mức năng lực theo bậc',
  'hrv.cap': 'Năng lực',
  'hrv.editing': 'Đang sửa · bấm ô để đổi mức',
  'hrv.capLevel': 'Mức mong đợi theo bậc',
  'hrv.cellAria': '{k} · {l} · mức {v}',
  'hrv.cellEdit': ' · bấm để đổi',
  'hrv.gapHd': 'Khoảng trống của nhóm',
  'hrv.gapUnder': '{n} người dưới mức',
  'hrv.gapCourse': 'khoá: {c}',
  'hrv.assign': 'Gán khoá',
  'hrv.edu': 'Mở HANA Edu ↗',
  'hrv.rvTitle': 'Phiếu đánh giá · {u}',
  'hrv.rvKpi': 'KPI kỳ · Mint-KPI',
  'hrv.rvKpiNone': 'Chưa có (thử việc)',
  'hrv.rvKpiTip': 'Điểm chất lượng KPI kỳ · lấy từ Mint-KPI (job, đúng hạn) · không tiền',
  'hrv.rvSelf': 'Tự ĐG',
  'hrv.rvScore': '{k} · {v} điểm',
  'hrv.rvTotal': 'Tổng {n}',
  'hrv.rvFormula': 'Tổng = 40% năng lực (quản lý chấm) + 60% KPI kỳ',
  'hrv.rvGrade': 'Xếp loại {g}',
  'hrv.rvNote': 'Nhận xét · mục tiêu kỳ tới',
  'hrv.rvNotePh': 'Điểm mạnh, việc cần cải thiện, khoá học đề xuất…',
  'hrv.rvDraft': 'Lưu nháp',
  'hrv.rvSend': 'Gửi kết quả',
  'hrv.nfCyc': 'Mở kỳ đánh giá',
  'hrv.nfOkr': 'Thêm mục tiêu',
  'hrv.nfName': 'Tên',
  'hrv.nfNamePh': 'Đánh giá quý I/2027',
  'hrv.nfType': 'Loại kỳ',
  'hrv.nfWho': 'Đối tượng',
  'hrv.nfCalNote': 'Hạn từng bước tính bằng ngày làm việc (WorkCalendar) · đặt ở bước sau khi tạo.',
  'hrv.nfLevel': 'Cấp',
  'hrv.nfOkrNote': 'Kết quả then chốt đo bằng job, tỷ lệ đúng hạn, số lượng — không đặt chỉ tiêu tiền ở đây.',
  'hrv.nfCancel': 'Huỷ',
  'hrv.nfCreate': 'Tạo',
  'hrv.mKpi': 'Mở KPI vận hành',
  'hrv.mKpiSub': 'Điểm KPI theo phòng / người · HANA Ezy',
  'hrv.mExp': 'Xuất kết quả đánh giá (Excel)',
  'hrv.mExpSub': 'Kỳ đang chọn · không có cột tiền',
  'hrv.mTpl': 'Mẫu phiếu đánh giá',
  'hrv.mTplSub': 'Năng lực 40% · KPI 60%',
  'hrv.tNotif': '4 thông báo mới · mở ở Việc & Duyệt',
  'hrv.tExp': 'Đang xuất kết quả {n}',
  'hrv.tTpl': 'Mở mẫu phiếu RV-STD-v2 (Draft)',
  'hrv.tRemindOne': 'Đã nhắc {w} · qua Hei + mail',
  'hrv.tRemindSelf': '{u} tự đánh giá',
  'hrv.tRemindMgr': '{m} chấm {u}',
  'hrv.tRemindAll': 'Đã nhắc {n} người · qua {via}',
  'hrv.tFull': 'Chấm đủ 5 năng lực trước khi gửi',
  'hrv.tSent': 'Đã gửi kết quả {u} · xếp loại {g} · chờ hiệu chỉnh',
  'hrv.tDraft': 'Đã lưu nháp phiếu {u}',
  'hrv.tCheckin': 'Đã check-in "{k}" · {v}',
  'hrv.tFrame': 'Đã lưu khung năng lực {p} · áp cho kỳ đánh giá sau',
  'hrv.tAssign': 'Đã gán khoá "{c}" cho {n} người · HANA Edu',
  'hrv.tCycNew': 'Đã tạo kỳ "{n}" (nháp) · đặt hạn rồi mở',
  'hrv.tOkrNew': 'Đã thêm mục tiêu "{n}"',
  'hrv.draftRange': 'Nháp · chưa đặt hạn',
  'hrv.emptyTitle': 'Chưa có kỳ đánh giá',
  'hrv.emptyDesc': 'Mở kỳ đầu tiên: chọn đối tượng, mẫu phiếu và hạn từng bước. Hệ thống tự nhắc qua Hei và mail.',
  'hrv.errTitle': 'Không tải được dữ liệu đánh giá',
  'hrv.errDesc': 'Mất kết nối tới máy chủ lúc 08:42. Phiếu đang soạn được giữ nháp trên máy.',
  'hrv.retry': 'Thử lại',
  'hrv.retrying': 'Đang tải lại…',
  'hrv.npTitle': 'Cần quyền nhóm HR',
  'hrv.npDesc': 'Màn đánh giá toàn công ty dành cho ghế HR / quản lý. Dữ liệu của bạn xem ở HANA Mee.',
  'hrv.npBtn': 'Mở HANA Mee',
  'hrv.close': 'Đóng',
});
